// 仓库、质检、维修、销售共用同意驳回操作；恢复状态只由后端决定。
export default {
    methods: {
        isSourceRejectPending(data) {
            return this.$options.handoverModuleType === 0
                ? !!data.buttons?.confirm_reject?.visible
                : Number(data.handover_state) === 9;
        },
        sourceHandoverStateText(data) {
            if (this.hasHandover === false) return '';
            return {6: '已调出', 8: '调拨中', 9: '被驳回中'}[data.handover_state] || '';
        },
        cancelReject(data) {
            this.$confirm({
                message: '撤销本次驳回？',
                buttonName: '确认',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/handover/reject/cancel',
                        data: {id: data.id},
                        loading: true,
                        success: (result, msg) => {
                            this.$message({message: msg, type: 'success'});
                            this.$refs.view.update();
                        },
                        fail: (msg) => {
                            this.$message({message: msg, type: 'warn'});
                            this.$refs.view.update();
                        }
                    });
                }
            });
        },
        confirmReject(rows) {
            const list = rows ? (Array.isArray(rows) ? rows : [rows]) : this.$refs.view.$refs.list.getData('selected');
            if (!list.length) {
                this.$message({message: '请选择需要同意驳回的商品', type: 'warn'});
                return;
            }
            if (list.some(item => !item.reject_handover_id || !item.buttons?.confirm_reject?.visible)) {
                this.$message({message: '请选择可同意驳回的被驳回中商品', type: 'warn'});
                return;
            }
            this.$confirm({
                message: '确定同意驳回所选的' + list.length + '条记录？',
                buttonName: '同意驳回',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: list.length === 1 ? '/handover/reject/confirm' : '/handover/reject/batchConfirm',
                        data: list.length === 1 ? {id: list[0].reject_handover_id} : {ids: list.map(item => item.reject_handover_id)},
                        loading: true,
                        success: (results, msg) => {
                            this.$refs.view.update();
                            const failed = Array.isArray(results) ? results.filter(item => !item.success) : [];
                            if (failed.length) {
                                const details = failed.map(item => {
                                    const row = list.find(row => String(row.reject_handover_id) === String(item.id));
                                    return (row ? row.produce_unique_code : '') + '：' + item.message;
                                }).join('；');
                                this.$confirm({message: msg + '。' + details, buttonName: '知道了', cancelButton: false});
                            } else {
                                this.$message({message: msg, type: 'success'});
                            }
                        },
                        fail: (msg) => {
                            this.$message({message: msg, type: 'warn'});
                            this.$refs.view.update();
                        }
                    });
                }
            });
        }
    }
};
